module.exports = __webpack_public_path__ + "img/marq01-1.9f0d75e5.jpg";